import type { HexColor } from 'src/types/colors';

export const colors: Record<string, HexColor> = {
  primary: '#E91E63',
  crimsonRed: '#C11920',
  vividCerulean: '#008EC6',
  gray900: '#2F353E',
  black: '#1E2127',
  white: '#FFFFFF',
  darkGray: '#222222',
  wechatGreen: '#2DC100',
  goldenYellow: '#fdd367',
  paleYellow: '#feefc0',
  warmOrange: '#ff751b',
  warmYellow: '#ffc552',
  gray500: '#b4b8be',
  darkBrown: '#563116',
  orangeRed: '#FE4600',
  jetBlack: '#1C1C1C',
  pink500: '#F06083',
  gray600: '#82878e',
  salmonPink: '#ee4f83',
  rakutenRed: '#BF0000',
  yamazakiOrange: '#D1690F',
  yamazakiGray: '#5B5B5B'
};
